<template>
  <v-card
    flat
    tile
    width="100%"
    class="footer-div lighten-1 text-center"
    v-if="!hideForTball"
  >
    <v-card-text class="d-flex justify-center mb-0 pb-0 mt-1">
      <div class="d-flex flex-wrap justify-center">
        <!-- <a class="text-decoration-none white--text"> About us </a> -->
        <!--<p class="white--text mx-4">|</p>
         <a
          href="reviewer-enrollment/info"
          class="text-decoration-none white--text"
        >
          Becoming a reviewer
        </a> -->
        <!-- <p class="white--text mx-4">|</p> -->
        <!-- <a class="text-decoration-none white--text"> FAQ </a>
        <p class="white--text mx-4">|</p> -->
        <a href="/legal" class="text-decoration-none white--text">
          Legal stuff
        </a>
        <p class="white--text mx-4">|</p>
        <a
          href="/legal#privacy-policy"
          class="text-decoration-none white--text"
        >
          Privacy policy
        </a>
        <p class="white--text mx-4">|</p>
        <a href="/support" class="text-decoration-none white--text">
          Support
        </a>
        <p class="white--text mx-4">|</p>
        <ReportProblem
          styleClass="text-decoration-none white--text"
          text="Report a problem"
        >
        </ReportProblem>
      </div>
    </v-card-text>

    <v-card-text class="white--text">
      {{ new Date().getFullYear() }} —
      <strong>faangit.com</strong>
      <p class="white--text">{{ $consts.VERSION }}</p>
    </v-card-text>
  </v-card>
</template>

<script>
import ReportProblem from "../components/ReportProblem.vue";

export default {
  data() {
    return {
      hideForTball: false,
    };
  },
  components: {
    ReportProblem,
  },
  mounted() {
    // check if path is /tball and hide footer if so
    if (this.$route.path === "/tball") {
      this.hideForTball = true;
    }
  },
};
</script>

<style scoped>
.footer-div {
  background: linear-gradient(-90deg, #02203d, #001527);
}
.footer-inner-div {
  max-width: 1200px;
}
</style>
